import React, { useState, useRef, useEffect } from 'react';
import { Droppable, Draggable } from 'react-beautiful-dnd';
import { EyeClosed } from '@blueprintnyc/bpnyc-common-admin/dist/icons';
import { CloseOutlined } from '@ant-design/icons';
import WidgetPreviews from 'components/WidgetPreviews';
import PhoneScreen from 'components/PhoneScreen/PhoneScreen';

const WidgetDevicePreview = props => {
	const { widgets, handleWidgetDelete, handleWidgetUpdate, onDelete, event, theme } = props;
	const [width, setWidth] = useState();
	const previewerRef = useRef();

	useEffect(() => {
		setWidth(previewerRef.current.clientWidth);
	}, []);

	const bgStyle =
		theme && theme.background_src
			? { backgroundImage: `url(${theme.background_src})` }
			: { backgroundColor: theme.background_color || '#FFFFFF' };

	return (
		<div className="WidgetDevicePreview" ref={previewerRef} style={{ width: '100%' }}>
			<div style={{ flex: 1, height: '100%' }}>
				<PhoneScreen theme={event.theme} divClassName="WidgetPhoneScreen">
					<Droppable droppableId="previewer">
						{(provided, snapshot) => (
							<>
								<div
									ref={provided.innerRef}
									{...provided.droppableProps}
									style={{
										...bgStyle,
										overflowY: 'scroll',
										height: '100%',
										backgroundSize: 'cover',
										backgroundRepeat: 'no-repeat',
										backgroundPosition: 'center',
									}}
								>
									{widgets.length ? (
										widgets.map((widget, index) => {
											return widget && widget.toDelete ? null : (
												<Draggable
													key={`${widget.type}-${index}`}
													draggableId={`${widget.type}-${widget.id}-${index}`}
													index={index}
												>
													{(provided, snapshot) => (
														<div
															key={`${index}`}
															ref={provided.innerRef}
															{...provided.draggableProps}
															{...provided.dragHandleProps}
															onClick={() => handleWidgetUpdate(widget, index)}
														>
															<div className="actions-hover-wrap">
																{widget.groups.length ? (
																	<div className="groups-icon">
																		<EyeClosed />
																	</div>
																) : null}
																<div className="delete-hover">
																	<CloseOutlined
																		style={{
																			padding: '.5em',
																			alignSelf: 'center',
																			color: 'black',
																			backgroundColor: 'white',
																			opacity: '.5',
																			borderRadius: '50%',
																		}}
																		onClick={e => onDelete(e, widget)}
																	/>
																</div>
																<div style={{}}>
																	<WidgetPreviews
																		type={widget.type}
																		handleDelete={handleWidgetDelete}
																		deviceWidth={width}
																		item={widget || {}}
																		style={{ color: theme.widgets_color }}
																	/>
																</div>
															</div>
														</div>
													)}
												</Draggable>
											);
										})
									) : (
										<div className="NoWidgetsMessage">
											Drag the widgets here to create your custom page
										</div>
									)}
									{provided.placeholder}
								</div>
							</>
						)}
					</Droppable>
				</PhoneScreen>
			</div>
		</div>
	);
};

export default WidgetDevicePreview;
